module.exports = ".child-name{top:-6px}\n"